export default import.meta.ROLLDOWN_FILE_URL_vcavL4RVRMfAVuZyxK23eA